import { useScrollAnimation } from '../hooks/useScrollAnimation'

export default function SectionHeader({ overline, headline, subtext, align = 'center', dark = false, className = '' }) {
  const ref = useScrollAnimation()

  return (
    <div
      ref={ref}
      className={`${align === 'center' ? 'text-center' : 'text-left'} ${className}`}
    >
      {overline && (
        <p className={`text-xs font-medium tracking-widest uppercase mb-4 ${dark ? 'text-[#22C55E]' : 'text-[#1B5E20]'}`}>
          {overline}
        </p>
      )}
      <h2 className={`font-display text-4xl lg:text-5xl leading-tight ${dark ? 'text-white' : 'text-charcoal'}`}>
        {headline}
      </h2>
      {subtext && (
        <p className={`mt-4 text-base lg:text-lg max-w-xl ${align === 'center' ? 'mx-auto' : ''} ${dark ? 'text-warm-grey' : 'text-slate'}`}>
          {subtext}
        </p>
      )}
    </div>
  )
}
